export enum MENU_TYPE {
    ANNOUNCEMENT = "ประกาศ",
    EXAM_BOOKING = "จองวันสอบ",
}
